<template>
    <b-card no-body>
        <b-card-header v-if="showCardHeader">
            <slot name="cardHeader">{{ cardTitle }}</slot>
        </b-card-header>
        <b-list-group flush v-if="!model.loading">
            <b-list-group-item v-if="paginate">
                <b-input-group>
                    <slot slot="prepend" name="filter_prepend" />
                    <b-form-input
                        v-model="itemFilter"
                        :placeholder="$t('label.filter')"
                    />
                    <slot slot="append" name="filter_append" />
                </b-input-group>
            </b-list-group-item>
            <slot
                name="modelContainer"
                v-for="model in modelItems.slice(
                    perPage * (currentPage - 1),
                    perPage * (currentPage - 1) + perPage
                )"
                v-bind:item="model"
            >
                <b-list-group-item>{{ model }}</b-list-group-item>
            </slot>
        </b-list-group>
        <b-card-body>
            <spinner v-if="model.loading" />
            <b-pagination
                v-if="!model.loading && modelItems.length > perPage"
                size="md"
                :total-rows="modelItems.length"
                v-model="currentPage"
                :per-page="perPage"
                hide-ellipsis
            ></b-pagination>
        </b-card-body>
    </b-card>
</template>

<script>
import Spinner from 'vue-spinner-component/src/Spinner'
import _ from 'lodash'

export default {
    name: 'ListGroupCard',
    props: {
        model: {
            type: Object,
            require: true,
        },
        paginate: {
            type: Boolean,
            default: true,
        },
        perPage: {
            type: Number,
            default: 10,
        },
        filterKey: {
            default: null,
        },
        fetchOnInit: {
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
        showCardHeader: {
            type: Boolean,
            default: true,
        },
    },
    components: {
        Spinner,
    },

    data() {
        return {
            itemFilter: '',
            currentPage: 1,
        }
    },

    created() {
        if (this.fetchOnInit) {
            this.model.fetch()
        }
    },

    computed: {
        cardTitle() {
            if (!this.title) {
                return this.model.constructor.name
            }

            return this.title
        },

        modelItems() {
            let filteredModels = this.model.models.filter(model => {
                let path = this.filterKey
                let filter = this.itemFilter

                return _.get(model, path, '')
                    .toLowerCase()
                    .indexOf(filter) > -1
                    ? true
                    : false
            })

            return filteredModels
        },
    },
    methods: {
        filterAttribute(attr) {
            if (!attr) {
                return false
            }

            attr = JSON.parse(JSON.stringify(attr))

            // Filter strings
            if (typeof attr === 'string') {
                return attr.toLowerCase().indexOf(this.itemFilter) > -1
            }

            // If is object
            if (typeof attr === 'object') {
                let ObjFilter = Object.values(attr).filter(this.filterAttribute)
                return ObjFilter.length > 0
            }
        },
    },
}
</script>
